import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { AmplitudeApi } from 'utils/amplitude';
import { Breadcrumb } from 'xland-ui';
import useCaptableBreadcrumb from 'routes/Captable/hook/useCaptableBreadcrumb';
import { ROUTE_STARTUP_PATH } from 'routes';
import SectionHeader from 'components/SectionHeader';
import SyndicatesTab from './SyndicatesTab';
import ShareholdersTab from './ShareholdersTab';

function Shareholders(props) {
  const {
    user,
    literalsCommon,
    literals,
    literalsShareholder,
    match,
    lang,
    startup,
    captable,
  } = props;

  const { CAP_TABLE_SHAREHOLDERS } = ROUTE_STARTUP_PATH;
  const { routes, nextRoutes } = useCaptableBreadcrumb(CAP_TABLE_SHAREHOLDERS, startup.id, captable.id);

  const tabs = [
    { key: 'shareholders', name: literals.shareholders },
    { key: 'syndicates', name: literals.syndicates },
  ];

  useEffect(() => {
    if (captable?.selected?.id) {
      AmplitudeApi.logEvent('startup.investors.main.view', {
        captable: captable?.selected?.id,
      });
    }
  }, [captable?.selected?.id]);

  return (
    <>
      <Breadcrumb routes={routes} nextRoutes={nextRoutes} />
      <SectionHeader tabs={tabs}>
        {tab => (
          <>
            {tab === 'shareholders' && (
              <ShareholdersTab
                literals={literals}
                literalsCommon={literalsCommon}
                literalsShareholder={literalsShareholder}
                startup={startup}
                captable={captable?.selected?.id}
                match={match}
                lang={lang}
              />
            )}
            {tab === 'syndicates' && (
              <SyndicatesTab
                literals={literals}
                literalsCommon={literalsCommon}
                literalsShareholder={literalsShareholder}
                user={user}
                startup={startup}
                match={match}
                lang={lang}
              />
            )}
          </>
        )}
      </SectionHeader>
    </>
  );
}

Shareholders.propTypes = {
  user: PropTypes.object.isRequired,
  literalsCommon: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  literalsShareholder: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  startup: PropTypes.object.isRequired,
  captable: PropTypes.object.isRequired,
};

export default Shareholders;
